import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";

function useUnhideWorkspace() {
  return useMutation((id) => servicesUtils.getService(`/workspaces/${id}/unhide/`));
}

export default useUnhideWorkspace;
